import { IIdentityLinksConfig, IIdentityLogoConfig, IIdentityProviderConfig, ISubscriberProviderConfig
    } from '../../../services/identity/adapters/adapter'
import { Entity } from '../../entity'

export interface IIdentityConfiguration {
    sso?: IIdentityProviderConfig
    subscriber?: ISubscriberProviderConfig
    gnsOptions?: IGnsOptionsConfig
}

export interface IGnsOptionsConfig {
    offerId: string
    templateId: string
}

export class IdentityConfiguration extends Entity implements IIdentityConfiguration {
    public logo?: IIdentityLogoConfig
    public links?: IIdentityLinksConfig
    public property?: string
    public sso?: IIdentityProviderConfig
    public subscriber?: ISubscriberProviderConfig
    public showPasswordPolicy?: boolean
    public gnsOptions?: IGnsOptionsConfig

    public fromJson(jsonObject: object): IIdentityConfiguration {
        super.fromJson(jsonObject)

        // parse provider objects
        if ((jsonObject as this).links) {
            this.links = (jsonObject as this).links
        }
        if ((jsonObject as this).sso) {
            this.sso = (jsonObject as this).sso
        }
        if ((jsonObject as this).subscriber) {
            this.subscriber = (jsonObject as this).subscriber
        }
        if ((jsonObject as this).gnsOptions) {
            this.gnsOptions = (jsonObject as this).gnsOptions
        }
        if ((jsonObject as this).logo) {
            this.logo = (jsonObject as this).logo
        }
        return this
    }
}
